import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui's class helper — last-wins merging of Tailwind classes. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Swiss number formatting: 1'649.86 (apostrophe group separator, dot decimal).
 * `Intl` with de-CH gives exactly this, including the apostrophe.
 */
const swissNumber = new Intl.NumberFormat('de-CH', { maximumFractionDigits: 3 })

export function formatNumber(
  value: number | string | boolean | null | undefined,
  booleanLabels: { yes: string; no: string } = { yes: 'ja', no: 'nein' },
): string {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'boolean') return value ? booleanLabels.yes : booleanLabels.no
  if (typeof value === 'string') return value
  if (!Number.isFinite(value)) return '—'
  return swissNumber.format(value)
}
